import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { EmployeeService } from '../../services/employees.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    Group
} from '../../models/models';

@Component({
    selector: 'employee-group-form',
    templateUrl: './employee-group-form.component.html',
    standalone: false
})
export class EmployeeGroupForm implements OnChanges {
    @Input() tableID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public tableItem: Group = {} as Group;

    constructor(private employeeService: EmployeeService, private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnChanges() {
        this.getTableItem();
        //console.log("ngOnChanges", this.tableID, this.carrierID);
    }

    private getTableItem() {
        if (this.tableID > 0) {
            this.utilService.isLoading = true;
            this.employeeService.getEmployeeGroupByID(this.tableID).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.resultCollection.length > 0) {
                    this.tableItem = result.resultCollection[0];
                }
            });
        }
        else {
            //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.tableItem = {
                groupId: 0,
                erpGroupId: "",
                name: ""
            };
        }
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.tableItem);
        this.employeeService.saveGroup(this.tableItem).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        this.tableItem = {} as Group;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}